// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__46FxY","ant-page-header-heading-title":"styles_ant-page-header-heading-title__E79SQ","table":"styles_table__6+F7F"};